import axiosInstance from "./axiosInstance";

function compactParams(params = {}) {
  const out = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === "" || value == null) return;
    out[key] = value;
  });
  return out;
}

const csrOutreachService = {
  getAccess: async () => (await axiosInstance.get("/admin/csr-outreach/access")).data,
  getStages: async () => (await axiosInstance.get("/admin/csr-outreach/stages")).data,
  getQuota: async (agent_id) =>
    (await axiosInstance.get("/admin/csr-outreach/quota", { params: agent_id ? { agent_id } : {} })).data,
  getPool: async (params = {}) =>
    (await axiosInstance.get("/admin/csr-outreach/customers/pool", { params: compactParams(params) })).data,
  getMine: async (params = {}) =>
    (await axiosInstance.get("/admin/csr-outreach/customers/mine", { params: compactParams(params) })).data,
  getAssignedUnreadTotal: async () =>
    (await axiosInstance.get("/admin/csr-outreach/customers/unread-total")).data,
  getTeam: async (params = {}) =>
    (await axiosInstance.get("/admin/csr-outreach/customers/team", { params: compactParams(params) })).data,
  lookupPhone: async (phone) =>
    (await axiosInstance.get("/admin/csr-outreach/customers/lookup-phone", { params: { phone } })).data,
  assign: async (user_ids) =>
    (await axiosInstance.post("/admin/csr-outreach/customers/assign", { user_ids })).data,
  assignByPhone: async (phone) =>
    (await axiosInstance.post("/admin/csr-outreach/customers/assign-by-phone", { phone })).data,
  releaseAssignment: async (assignmentId, payload = {}) =>
    (
      await axiosInstance.post(
        `/admin/csr-outreach/customers/assignments/${assignmentId}/release`,
        payload
      )
    ).data,
  listRemovedCustomers: async (params = {}) =>
    (await axiosInstance.get("/admin/csr-outreach/customers/removed", { params })).data,
  reassignAssignment: async (assignmentId, agent_id) =>
    (await axiosInstance.put(`/admin/csr-outreach/customers/assignments/${assignmentId}/reassign`, {
      agent_id,
    })).data,
  updateStage: async (id, stage_id) =>
    (await axiosInstance.put(`/admin/csr-outreach/customers/${id}/stage`, { stage_id })).data,
  updateBuyPremium: async (id, buy_premium) =>
    (await axiosInstance.put(`/admin/csr-outreach/customers/${id}/buy-premium`, { buy_premium })).data,
  createPremiumRequest: async (id, payload) =>
    (await axiosInstance.post(`/admin/csr-outreach/customers/${id}/premium-request`, payload)).data,
  createManualSubscriptionRequest: async (payload) =>
    (await axiosInstance.post("/admin/csr-outreach/manual-subscription-request", payload)).data,
  getPremiumRequests: async (params = {}) =>
    (await axiosInstance.get("/admin/csr-outreach/premium-requests", { params })).data,
  approvePremiumRequest: async (id, payload) =>
    (await axiosInstance.put(`/admin/csr-outreach/premium-requests/${id}/approval`, payload)).data,
  logCallMinutes: async (payload) =>
    (await axiosInstance.post("/admin/csr-outreach/calls/log-minutes", payload)).data,
  getCallHistory: async (userId) =>
    (await axiosInstance.get(`/admin/csr-outreach/customers/${userId}/calls`)).data,
  deleteCallRecord: async (id) =>
    (await axiosInstance.delete(`/admin/csr-outreach/calls/${id}`)).data,
  deleteCustomerAssignment: async (assignmentId) =>
    (await axiosInstance.delete(`/admin/csr-outreach/customers/assignments/${assignmentId}`)).data,
  getPerformance: async (params = {}) =>
    (await axiosInstance.get("/admin/csr-outreach/performance", { params })).data,
  getTargets: async (params = {}) =>
    (await axiosInstance.get("/admin/csr-outreach/targets", { params })).data,
  saveTargets: async (payload) =>
    (await axiosInstance.put("/admin/csr-outreach/targets", payload)).data,
  getTeams: async () => (await axiosInstance.get("/admin/csr-outreach/teams")).data,

  contact: async (userId) =>
    (await axiosInstance.post(`/admin/csr-outreach/customers/${userId}/contact`)).data,
  getChat: async (userId, params = {}) =>
    (await axiosInstance.get(`/admin/csr-outreach/customers/${userId}/chat`, { params })).data,
  markChatSeen: async (userId) =>
    (await axiosInstance.post(`/admin/csr-outreach/customers/${userId}/chat/mark-seen`)).data,
  sendMessage: async (userId, message) =>
    (await axiosInstance.post(`/admin/csr-outreach/customers/${userId}/chat/message`, { message })).data,
  sendVoice: async (userId, blob, voiceMeta) => {
    const form = new FormData();
    form.append("file", blob, "voice.webm");
    const waveform = voiceMeta && voiceMeta.waveform;
    if (Array.isArray(waveform) && waveform.length) {
      form.append("voice_waveform", JSON.stringify(waveform));
    }
    if (voiceMeta && voiceMeta.durationMs) {
      form.append("voice_duration_ms", String(voiceMeta.durationMs));
    }
    return (
      await axiosInstance.post(`/admin/csr-outreach/customers/${userId}/chat/voice`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
    ).data;
  },
  sendImage: async (userId, file) => {
    const form = new FormData();
    form.append("file", file);
    return (
      await axiosInstance.post(`/admin/csr-outreach/customers/${userId}/chat/image`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
    ).data;
  },
  initiateCall: async (userId) =>
    (await axiosInstance.post(`/admin/csr-outreach/customers/${userId}/call`, { call_type: "voice" })).data,
  endCall: async (userId, payload) =>
    (await axiosInstance.post(`/admin/csr-outreach/customers/${userId}/call/end`, payload)).data,
};

export default csrOutreachService;
